import img1 from '../../assets/img/home3/s1.svg';
import img2 from '../../assets/img/home3/s2.svg';
import img3 from '../../assets/img/home3/s3.svg';
import img4 from '../../assets/img/home3/s4.svg';
import img5 from '../../assets/img/home3/s5.svg';
import img6 from '../../assets/img/home3/s6.svg';

const servicesThreeData = [
    {
        id: 'svc3-1',
        img: img1,
        title: 'Renovation & Fit-Out',
        desc: 'We transform spaces with quality renovation and fit-out solutions tailored to your vision and budget.',
    },
    {
        id: 'svc3-2',
        img: img2,
        title: 'AC Maintenance & Installation',
        desc: 'Expert AC installation and maintenance services to keep your space cool, efficient, and comfortable.',
    },
    {
        id: 'svc3-3',
        img: img3,
        title: 'MEP Service',
        desc: 'Reliable Mechanical, Electrical, and Plumbing services for residential and commercial projects.',
    },
    {
        id: 'svc3-4',
        img: img4,
        title: 'Flooring & Painting',
        desc: 'Premium flooring and painting solutions that enhance the aesthetics and durability of any space.',
    },
    {
        id: 'svc3-5',
        img: img5,
        title: 'Gypsum Partitions & Ceilings',
        desc: 'Custom gypsum partition and ceiling designs that add elegance and functionality to interiors.',
    },
    {
        id: 'svc3-6',
        img: img6,
        title: 'Annual Maintenance (AMC) for AC and MEP',
        desc: 'Scheduled AMC plans to ensure your AC and MEP systems run smoothly all year round.',
    },
]

export default servicesThreeData;